module.exports = __webpack_public_path__ + "img/logo-white.a95e0352.svg";